import * as React from "react";
import { Viewport, ViewSmall, ViewMedium } from "bernie-view";

import { UitkCarousel } from "uitk-react-carousel";
import { UitkLayoutGrid } from "uitk-react-layout-grid";

import DestinationCard from "./DestinationCard";
import { ItemKeyHelper } from "components/utility/ItemKeyHelper";
import { withStores } from "stores";
import { dxThumborizeImage } from "components/utility/DxThumborizeImage";

import { AspectRatioEnum } from "stores/thumbor/ThumborStore";
import { useLocalization } from "@shared-ui/localization-context";
import { CardsViewProps, Destination } from "components/shared/DestinationCardView/typings";

const CardsView = withStores("thumbor")((props: CardsViewProps) => {
  const { baseKey, context, destinations, thumbor, localiseKey, moduleName } = props;
  const keyHelper = new ItemKeyHelper(baseKey);
  const { formatText } = useLocalization();

  const destinationCards = destinations.map((destination: Destination) => {
    const name = destination.localisedName || destination.name;

    const thumborizedImage = dxThumborizeImage(
      thumbor,
      destination.image,
      name,
      512,
      288,
      context,
      AspectRatioEnum.DEFAULT,
      true,
      80
    );

    return (
      <DestinationCard
        key={keyHelper.next()}
        name={name}
        description={destination.description}
        url={destination.url}
        thumborizedImage={thumborizedImage}
        localiseKey={localiseKey}
        moduleName={moduleName}
      />
    );
  });

  return (
    <Viewport>
      <ViewSmall>
        <UitkCarousel
          carouselName="DestinationCards"
          buttonText={{
            nextButton: formatText("carousel.item.next"),
            prevButton: formatText("carousel.item.prev"),
          }}
          itemsVisible={{ sm: 1, md: 1, lg: 1 }}
          pageBy={1}
          peekWidth={20}
        >
          {destinationCards}
        </UitkCarousel>
      </ViewSmall>

      <ViewMedium>
        <UitkLayoutGrid columns={{ medium: 2, large: 3, extra_large: 4 }} space="three">
          {destinationCards}
        </UitkLayoutGrid>
      </ViewMedium>
    </Viewport>
  );
});

export default CardsView;
